import { render, staticRenderFns } from "./PhotoSwipeGallery.vue?vue&type=template&id=43b2b4d0&lang=pug&"
import script from "./PhotoSwipeGallery.vue?vue&type=script&lang=js&"
export * from "./PhotoSwipeGallery.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSwipeGallery.vue?vue&type=style&index=0&id=43b2b4d0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports